import {
  POBREZA_CRONICA_ARGENTINA_BUCKETS,
  POBREZA_CRONICA_ARGENTINA_LEGEND,
} from '../components/LayerSelectorPanel/MapLayerOptions';

const MISSING_VALUE_COLOR = 'rgba(255,255,255,0.38)';
const NO_BAND_COLOR = 'rgba(255,255,255,0.55)';

/** Parsea `chronic_poverty_pct` (% personas en pobreza crónica, 0–100). null = ausente en API. */
export const parseChronicPovertyPct = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number(String(value).trim().replace(',', '.'));
  if (!Number.isFinite(n)) return null;
  return Math.min(100, Math.max(0, n));
};

/** Bucket según bandas de la capa Pobreza Crónica (Censo 2010). */
export const getChronicPovertyBucket = (pct) => {
  const p = Number(pct);
  if (!Number.isFinite(p)) return null;
  return POBREZA_CRONICA_ARGENTINA_BUCKETS.find(
    (band) => p >= band.pctMin && p <= band.pctMax,
  ) ?? null;
};

export const buildChronicPovertyTooltipMessage = ({
  pctRounded,
  level = null,
  isMissing = false,
}) => {
  if (isMissing) {
    return 'No hay datos de pobreza crónica disponibles para el radio censal de este lote.';
  }

  const base = (
    `El lote se ubica en un radio censal donde el ${pctRounded}% de las personas `
    + 'está en situación de pobreza crónica.'
  );
  if (level) return `${base} Nivel de incidencia: ${level}.`;
  return base;
};

/**
 * Presentación de pobreza crónica para el panel del lote.
 * Campo API: `chronic_poverty_pct` (% personas en pobreza crónica).
 */
export const getChronicPovertyPanelDisplay = (value) => {
  const parsed = parseChronicPovertyPct(value);
  const isMissing = parsed === null;
  const pct = parsed ?? 0;
  const pctRounded = Math.round(pct);
  const bucket = isMissing ? null : getChronicPovertyBucket(pct);
  const levelLabel = bucket?.shortLabel ?? null;

  const accentColor = isMissing
    ? MISSING_VALUE_COLOR
    : (bucket?.color ?? NO_BAND_COLOR);

  return {
    status: 'ready',
    isMissing,
    pct,
    pctLabel: `${pctRounded}%`,
    level: levelLabel,
    accentColor,
    tooltip: buildChronicPovertyTooltipMessage({
      pctRounded,
      level: levelLabel,
      isMissing,
    }),
  };
};

export { POBREZA_CRONICA_ARGENTINA_LEGEND };
